import { dataHooks } from '../constants';
import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';

export const togglePrivateDriverFactory = base => {
  const { element, exists } = baseUniDriverFactory(base);

  return {
    exists,
    element,
    getToggleStyles: () =>
      base
        .$$(`[data-hook="${dataHooks.toggleStyles}"]`)
        .map(div => div.attr('style')),
    getContentText: () => base.text(),
  };
};
